module.exports = __webpack_public_path__ + "media/images/dividend/map_animation_2-38d9ef54c11674db8be3d119eb11cb0c.gif";